module.exports = __webpack_public_path__ + "img/sld_battery_1_dark.519ee2a5.svg";